module.exports = __webpack_public_path__ + "static/media/butterfly-first-page.921eb694.svg";